import React, { useState } from 'react';
import '../App.css';

// Simulación de usuario logueado (reemplazar por lógica real cuando haya backend)
const usuarioLogueado = true; // Cambia a false para probar el estado no logueado

const Contacto = () => {
  const [enviado, setEnviado] = useState(false);

  if (!usuarioLogueado) {
    return (
      <section className="contacto-page">
        <h2>Contacto y Devoluciones</h2>
        <p>Debes iniciar sesión para enviar consultas, devoluciones, quejas o reclamos.</p>
        <a href="/login" className="contacto-login-btn">Iniciar sesión</a>
      </section>
    );
  }

  if (enviado) {
    return (
      <section className="contacto-page">
        <h2>Contacto y Devoluciones</h2>
        <p>¡Tu mensaje fue enviado correctamente! Pronto recibirás una respuesta.</p>
      </section>
    );
  }

  return (
    <section className="contacto-page">
      <h2>Contacto y Devoluciones</h2>
      <p>¿Tenés una consulta, reclamo, queja o querés solicitar una devolución? Completá el siguiente formulario y te responderemos a la brevedad.</p>
      <form className="contacto-form-placeholder" onSubmit={e => { e.preventDefault(); setEnviado(true); }}>
        <input type="text" placeholder="Nombre completo" required />
        <input type="email" placeholder="Correo electrónico" required />
        <select required>
          <option value="">Tipo de consulta</option>
          <option value="consulta">Consulta general</option>
          <option value="devolucion">Devolución</option>
          <option value="reclamo">Reclamo</option>
          <option value="queja">Queja</option>
        </select>
        <textarea placeholder="Escribí tu mensaje aquí..." rows={5} required />
        <button className="contacto-enviar-btn" type="submit">Enviar</button>
      </form>
    </section>
  );
};

export default Contacto; 